<ng-container *ngIf="actionList?.length">
    <button (click)="preventClick($event)" mat-icon-button [matMenuTriggerFor]="menu" aria-label="Expand the row actions menu">
        <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
        <div *ngFor="let action of actionList" class="action-menu-item action-btn" mat-menu-item>
            <span (click)="emitTableAction($event, action)" class="table-action">
                {{ action.title }}
            </span>
        </div>
    </mat-menu>
</ng-container>
